import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { CommandPalette } from './components/CommandPalette';
import { installAuthorizedFetch } from './lib/net/authorizedFetch';
import { ThemeProvider } from './lib/theme/ThemeProvider';
import { Toaster } from './ui/primitives/Toast';
import './styles/globals.css';

// Install the fetch wrapper before any user interaction. The module-
// level capture in `./lib/net/authorizedFetch` already read the
// native `globalThis.fetch` at import time, so this call only swaps
// the global reference. Guest sessions run with an empty allow-list
// (see `./lib/net/allowList.ts`), enforcing the zero-network
// invariant from P-01.3 and `.claude/CLAUDE.md §2` at runtime — CI
// enforcement lives in `apps/web/e2e/guest-flow.spec.ts`.
installAuthorizedFetch();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
        {/* S-043: global command palette, opens on Cmd+K / Ctrl+K
            from any route. Mounts once at app root so the hotkey
            listener is available everywhere. */}
        <CommandPalette />
        {/* Themed Sonner wrapper from `./ui/primitives/Toast` — reads
            chrome + semantic tokens. `richColors` uses `success` /
            `error` / `warning` variants from the design tokens.
            Position defaults to top-right. */}
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
